import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map } from 'rxjs/operators';
import * as fromServiceGroupSubCategories from './service-group-sub-categories.actions';
import { ServiceGroupSubCategoriesState } from './service-group-sub-categories.interfaces';
@Injectable()
export class ServiceGroupSubCategoriesEffects {
  
  getServiceGroupSubCategoriesFromServer = createEffect(() => this.dataPersistence.fetch(
    fromServiceGroupSubCategories.GET_SERVICE_GROUP_SUB_CATEGORIES_FROM_SERVER,
    {
      run: (action: fromServiceGroupSubCategories.GetServiceGroupSubCategoriesFromServer, state: any) => {
        if (state.svcDropdowns.serviceGroupSubCategories.ids.length === 0) {
          return this.apiService
            .get<any[]>(`v/1/associates/associate-classes`, {
              params: action.payload
            })
            .pipe(
              map((serviceGroupSubCategories: any[]) => {
                return new fromServiceGroupSubCategories.GetServiceGroupSubCategoriesFromServerSuccess({
                  serviceGroupSubCategories: serviceGroupSubCategories
                });
              })
            );
        }
      },
      onError: (action: fromServiceGroupSubCategories.GetServiceGroupSubCategoriesFromServer, error) => {
        console.error('Error', error);
      }
    }
  ));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<ServiceGroupSubCategoriesState>,
    private apiService: ApiService
  ) {}
}
